/// <reference path="../_references.ts"/>

module App.WorkOrderTemplate {
	export type Package = {
		id: number;
		code: string;
		name: string;
	}

	export type Template = {
		id: number;
		creator: string;
		favorited: boolean;
		packages: Package[];
		times_loaded: number;
		name: string;
	};
}